module.exports = __webpack_public_path__ + "img/Contact_design_s.1eaba462.jpeg";